const skills=[
  {
    "title": "HTML",
    "imageSrc": require("../images/skills/html.png")
  },
  {
    "title": "CSS",
    "imageSrc": require("../images/skills/css.png")
  },
  {
    "title": "JavaScript",
    "imageSrc": require("../images/skills/JavaScript-logo.png")
  },
  {
    "title": "React",
    "imageSrc": require("../images/skills/react.png")
  },
  {
    "title": "Next.Js",
    "imageSrc": require("../images/skills/nextjs-Photoroom.png-Photoroom.png")
  },
  {
    "title": "Node",
    "imageSrc": require("../images/skills/node.png")
  },
  {
    "title": "Express.Js",
    "imageSrc": require("../images/skills/express-Photoroom.png-Photoroom.png")
  },
  {
    "title": "Java",
    "imageSrc": require("../images/skills/Java-Logo (1).png")
  },
  {
    "title": "Spring Boot",
    "imageSrc": require("../images/skills/springboot-Photoroom.png-Photoroom.png")
  },
  {
    "title": "MySQL",
    "imageSrc": require("../images/skills/Mysql_logo.png")
  },
  {
    "title": "MongoDB",
    "imageSrc": require("../images/skills/mongodb.png")
  }
];

module.exports = skills; 